import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import i18n from 'i18n/config';

import ConversionPopover from './ConversionPopover';
import styles from './indianWallet.module.scss';

const conversionRateLabel = i18n.t('headerFooter:header.wallet.conversionRate');
const ConversionRate = () => {
  const { inrConversionRate } = useWalletIndianExchange();
  return (
    (<div className={styles['conversion-rate']} data-palette="ConversionRate">
      <div className="flex-set">
        <span>{conversionRateLabel}: </span>
        <span className={styles.highlight}>1 USD = INR {inrConversionRate} </span>
        <ConversionPopover />
      </div>
    </div>)
  );
};

export default ConversionRate;
